import classNames from 'classnames'
import { MdCheck } from 'react-icons/md'
import s from './Checkbox.scss'

const Checkbox = ({
  isChecked,
  triggerCheckbox,
  hasWhiteBorder,
  size = 'sm',
  className,
  cy,
  disabled
}) => (
  <label
    className={classNames(
      className,
      {
        [s.isActiveWhite]: isChecked && hasWhiteBorder,
        [s.isActive]: isChecked && !hasWhiteBorder,
        [s.isDisabled]: disabled
      },
      s.container,
      s[size]
    )}
    data-cy={cy}
  >
    {isChecked && <MdCheck className={s.checkmark} style={{ verticalAlign: 'top' }} />}
    <input
      type="checkbox"
      onChange={triggerCheckbox}
      checked={isChecked}
      className={s.checkbox}
      disabled={disabled}
    />
  </label>
)

export default Checkbox
